import ReactDOM from "react-dom/client";
import {DisconnectWifiIcon} from "../icons/material-icons";
import React from "react";
import {HideMainLoading} from "./architecture";

const tc = document.getElementById('tc40R3');
const root = ReactDOM.createRoot(tc as HTMLElement);

export const ShowConnectionFailed = (lang: string) => {
    const AA = () => {
        const reloadPressed = () => window.location.reload();
        React.useEffect(()=>{
            HideMainLoading();
            document.body.classList.add('body-no-scroll');
            tc!.classList.add('active');
        },[]);
        return (
            <div>
                <i><DisconnectWifiIcon/></i>
                <h1>ارتباط برقرار نشد</h1>
                <button onClick={reloadPressed}>تلاش مجدد</button>
            </div>
        );
    };
    root.render(<AA/>);
};
export const HideConnectionFailed = (lang:string) =>{
    tc!.classList.remove('active');
};